import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../../../environments/environment';
import { DealOriginRequest, DealOriginResponse } from '../models/deal-origin.model';

@Injectable({ providedIn: 'root' })
export class DealOriginApiService {
  private readonly apiUrl = `${environment.apiUrl}api/deal-origins`;

  constructor(private http: HttpClient) {}

  getAll(): Observable<DealOriginResponse[]> {
    return this.http.get<DealOriginResponse[]>(this.apiUrl);
  }

  getById(id: number): Observable<DealOriginResponse> {
    return this.http.get<DealOriginResponse>(`${this.apiUrl}/${id}`);
  }

  create(req: DealOriginRequest): Observable<DealOriginResponse> {
    return this.http.post<DealOriginResponse>(this.apiUrl, req);
  }

  update(id: number, req: DealOriginRequest): Observable<DealOriginResponse> {
    return this.http.put<DealOriginResponse>(`${this.apiUrl}/${id}`, req);
  }

  delete(id: number): Observable<void> {
    return this.http.delete<void>(`${this.apiUrl}/${id}`);
  }
}
